var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161.763,
    height: 66.784,
    viewBox: "0 0 161.763 66.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;stroke-width:2px;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{clip-path:url(#c);}.e{clip-path:url(#d);}.f{clip-path:url(#e);}.g{clip-path:url(#f);}.h{clip-path:url(#g);}.i{clip-path:url(#h);}.j{clip-path:url(#i);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.618,49.608A2.064,2.064,0,1,0,81.677,47.7a1.987,1.987,0,0,0-2.059,1.909",
    transform: "translate(-79.618 -47.699)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.395,58.571A2.209,2.209,0,1,0,72.6,56.362a2.21,2.21,0,0,0-2.209,2.209",
    transform: "translate(-70.395 -56.362)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.979,67.2a1.913,1.913,0,1,0,1.913-1.907A1.91,1.91,0,0,0,79.979,67.2",
    transform: "translate(-79.979 -65.288)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.561,58.215a2.1,2.1,0,1,0,2.1-1.946,2.025,2.025,0,0,0-2.1,1.946",
    transform: "translate(-88.561 -56.269)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.337,71.284h6.012a6.7,6.7,0,0,1,0,13.405H99.337ZM97.22,69.167V92.45h2.117V86.805h6.012a8.951,8.951,0,0,0,2.681-.395l3.076,6.04h2.37l-3.528-6.914a9.55,9.55,0,0,0,1.636-1.327,8.819,8.819,0,0,0-6.236-15.042H97.22Z",
    transform: "translate(-97.22 -69.167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M135.237,75.3,129.9,82.663,124.541,75.3h-2.625l6.66,9.171-6.66,9.173h2.625l5.362-7.366,5.335,7.366h2.624L131.2,84.468l6.661-9.171Z",
    transform: "translate(-121.916 -75.297)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M174.871,69.167,164.682,83.334,154.438,69.167h-1.75V92.45H154.8V73.287l8.947,12.389h1.863l8.946-12.446V92.45h2.117V69.167Z",
    transform: "translate(-152.688 -69.167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M192.106,89.788A7.773,7.773,0,0,1,203.1,78.795a8.275,8.275,0,0,1,1.553,2.2v6.6a7.84,7.84,0,0,1-1.553,2.173,7.765,7.765,0,0,1-10.993.014m-1.5-12.475a9.878,9.878,0,0,0,6.985,16.863,9.635,9.635,0,0,0,7.056-2.964v2.258h2.117V75.1h-2.117v2.286a9.639,9.639,0,0,0-7.056-2.964,9.518,9.518,0,0,0-6.985,2.893",
    transform: "translate(-187.717 -74.42)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.236,75.3,223.9,82.663,218.54,75.3h-2.625l6.661,9.171-6.661,9.173h2.625l5.363-7.366,5.334,7.366h2.625l-6.66-9.173,6.66-9.171Z",
    transform: "translate(-215.915 -75.297)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.198 -18.463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.2 42.213)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.117,
    height: 3.817,
    transform: "translate(0 0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.769 49.193)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.418,
    height: 4.418
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.491 56.384)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.826,
    height: 3.816
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.294 19.463)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.778,64.357a6.75,6.75,0,0,1-1.421-.583C6.391,62.691,1.046,59.184.671,52.838a9.823,9.823,0,0,1,2.768-7.372L16.146,32.239,2.471,18.824A6.875,6.875,0,0,1,1.088,16.9C-.026,14.578-1.474,9.5,3.537,4.264A12.8,12.8,0,0,1,12.756,0a13.239,13.239,0,0,1,9.2,4.1c.228.22.436.47.652.724l9.641,9.338,1.873,1.822s1.894,1.393-1.338,3.567L20.446,32.141,32.51,43.3a12.788,12.788,0,0,0,1.129.934c.892.651,2.652,2.2,1.244,3.437L22.6,60.259s-3.879,4.526-9.722,4.526A11.638,11.638,0,0,1,9.778,64.357Zm8.207-29.908L6.136,46.3s-5.423,5.823,0,12.253a10.754,10.754,0,0,0,7.122,3.209,9.313,9.313,0,0,0,6.134-2.508l12.5-12.3L18.386,34.147ZM8.4,3.62C.532,8.176,3.256,14.675,4.635,17.057a6.294,6.294,0,0,0,1.123,1.423l12.578,11.9L31.491,17.176,19.742,6.13A9.126,9.126,0,0,0,12.615,2.72,10.338,10.338,0,0,0,8.4,3.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.406 49.118)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.193,
    height: 3.891,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.382 59.51)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16.933,
    height: 23.283
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.28 64.448)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.946,
    height: 18.344,
    transform: "translate(0 0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.073 59.51)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.99,
    height: 23.283
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.295 63.742)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.051,
    height: 19.757,
    transform: "translate(0 0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.015 64.448)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.946,
    height: 18.344,
    transform: "translate(0 0.001)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.84a299680d2498e75900779938a00310.svg";
export { ForwardRef as ReactComponent };